<div class="flex flex-row mt-2.5 p-4 md:p-0">
  @if (mode() === "normal") {
    <div class="pr-3.5 pl-2.5 pt-1">
      <div class="avatar">{{ userName()[0] }}</div>
    </div>
  }
  <div class="mr-1">
    <div class="flex flex-col">
      @if (mode() === "normal" && userName()) {
        <div>
          <span class="text-sm font-bold mr-0.5">{{ userName() }}</span>
        </div>
      }
      <div class="whitespace-pre-wrap" [innerHTML]="text()"></div>
    </div>
  </div>
</div>
